import React from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../../../../Shared/LoadingOverlay';
import SelectTipo from '../../../../Shared/SelectTipo';
import Indicadores from './indicadores';

// import { cleanGraphicsSetting } from "../../../Graficos/actions";
import ReportSiniestros from './graficos/siniestros';
import ReportDeununcias from './graficos/denuncias';
import PrestacionesGrafico from './graficos/prestaciones';
import { setRangeMonth } from './actions';

import { push } from 'connected-react-router';
import { checkAccess, ids, realCheckAccess } from '../../../../../helpers/rolAccess';
import { paths } from '../../../../../config/routes';

const Data = [
  { name: 'trabajo', value: 10 },
  { name: 'trayecto', value: 22 },
  { name: 'enfermedad', value: 0 },
];
class Resumen extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root));
    }
  };

  handleSelectTipo = (e) => {
    this.props.dispatch(setRangeMonth(e.value));
  };

  renderIndicadores = () => (
    <React.Fragment>
      <div className='indicadoresCard-flex'>
        <div className='indicadoresCard-content'>
          <span className='dx-form-group-caption' style={{ color: '#004A52', marginTop: 10 }}>
            {' '}
            Siniestro de Enero 2018{' '}
          </span>
          <Indicadores sources={Data} />
        </div>
        <div className='indicadoresCard-content'>
          <span className='dx-form-group-caption' style={{ color: '#004A52', marginTop: 10 }}>
            Siniestro de Enero 2019
          </span>
          <Indicadores />
        </div>
      </div>
    </React.Fragment>
  );

  render() {
    return (
      <div className='sinisterRoot'>
        {this.props.isLoadingGraphics && <LoadingOverlay />}
        {/* <div style={{ marginBottom: 40 }} >
          {this.renderIndicadores()}
        </div> */}
        <div>
          <div className='indicadoresCard-flex'>
            <div className='tituloSeccion'>
              {' '}
              <span className='texto'> Periodo de consulta: </span>
              <SelectTipo
                selected={this.props.selectedOption}
                onClick={this.handleSelectTipo}
                items={[
                  { name: '12 meses anteriores', value: '12' },
                  { name: '6 meses anteriores', value: '6' },
                  { name: '3 meses anteriores', value: '3' },
                ]}
              />
            </div>
          </div>
          <div style={{ marginLeft: 3 }}>
            <div className='dx-form-group-caption'>
              <h4>Siniestros</h4>
            </div>
            <div className='dashboard-card'>
              {this.props.EmbedTokenPowerBi ? <ReportSiniestros /> : null}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: 40, marginLeft: 3 }}>
          <div className='row'>
            <div className='col-md-12 col-xl-6 indicadoresCard-content'>
              <div className='dx-form-group-caption'>
                <h4>Denuncias</h4>{' '}
              </div>
              <div className='dashboard-card'>
                {this.props.EmbedTokenPowerBi ? <ReportDeununcias /> : null}
              </div>
            </div>
            <div className='col-md-12 col-xl-6 indicadoresCard-content'>
              <div className='dx-form-group-caption'>
                <h4>Prestaciones Económicas</h4>
              </div>
              <div className='dashboard-card'>
                {this.props.EmbedTokenPowerBi ? <PrestacionesGrafico /> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.resumenEmpresa.isLoading,
  selectedOption: state.resumenEmpresa.selectedOption,
  isLoadingGraphics: state.graficos.isLoading,

  userAccessIds: state.global.userAccessIds,
  showHideGriphics: state.graficos.showHideGriphics,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,

  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Resumen);
